export default "__VITE_ASSET__yIxWVGbg__"